import React from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import NumberFormat from "react-number-format";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import {InputText} from "primereact/inputtext";
import ContextMenu from "../../../components/contextMenu";
import LoadingOverlay from 'react-loading-overlay';

const CustodyTitlesView = ({...props}) => {
    return (
        <React.Fragment>
            <LoadingOverlay
                active={props.isLoading}
                spinner
                text='Loading...'>
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            {props.messagesGrowl}
                            <HeaderScreenPresval headerTitle="Operación \ Custodia de Títulos"
                                                 onExpand={props.clearFilters}
                                                 actionSearch={props.searchContingency}>
                                <div className="p-grid">
                                    <div className="p-col-12 p-md-3 p-col-3">
                                        <SubtitleLabel header="Folio" isBold={true}/>
                                        <NumberFormat
                                            name="folioFilter"
                                            thousandSeparator={false}
                                            placeholder="Ex. 1000"
                                            onChange={props.onChangeFilter}
                                            value={props.folioFilter}
                                            customInput={InputText}/>
                                    </div>
                                    <div className="p-col-12 p-md-2 p-col-2">
                                        <SubtitleLabel header="Prestamista" isBold={true}/>
                                        <Dropdown
                                            name="ptmFilter"
                                            filter={true}
                                            filterBy="lenderName"
                                            options={props.catLender}
                                            optionLabel="lenderName"
                                            placeholder="Seleccione..."
                                            onChange={props.onChangeFilter}
                                            value={props.ptmFilter}/>
                                    </div>
                                    <div className="p-col-12 p-md-2 p-col-2">
                                        <SubtitleLabel header="Prestatario" isBold={true}/>
                                        <Dropdown
                                            name="pttFilter"
                                            filter={true}
                                            filterBy="borrowerName"
                                            options={props.catBorrower}
                                            optionLabel="borrowerName"
                                            placeholder="Seleccione..."
                                            onChange={props.onChangeFilter}
                                            value={props.pttFilter}/>
                                    </div>
                                    <div className="p-col-12 p-md-2 p-col-2">
                                        <SubtitleLabel header="Estatus" isBold={true}/>
                                        <Dropdown
                                            name="catStatusFilter"
                                            filter={true}
                                            filterBy="statusName"
                                            options={props.catStatus}
                                            optionLabel="statusName"
                                            placeholder="Seleccione..."
                                            onChange={props.onChangeFilter}
                                            value={props.catStatusFilter}/>
                                    </div>
                                    <div className="p-col-12 p-md-2 p-col-2">
                                        <SubtitleLabel header="Tipo instrucción" isBold={true}/>
                                        <Dropdown
                                            name="catInstructionTypeFilter"
                                            filterBy="instructionName"
                                            options={props.catInstructionType}
                                            optionLabel="instructionName"
                                            placeholder="Seleccione..."
                                            onChange={props.onChangeFilter}
                                            value={props.catInstructionTypeFilter}/>
                                    </div>
                                    <div className="p-col-12 p-md-1 p-col-1"/>
                                    <div className="p-col-12 p-md-12 p-col-12">
                                        <Button label="Limpiar"
                                                style={{'float': 'right'}}
                                                onClick={props.clearFilters}
                                                className="p-button-secondary"/>
                                    </div>
                                </div>
                            </HeaderScreenPresval>
                        </Grid>
                        <Grid item xs={12}>
                            <div className="p-grid p-align-center p-justify-end">
                                <div className="p-col-12 p-md-12 p-col-12" style={{textAlign: 'right'}}>
                                    <ContextMenu menuOptions={props.exportOptions}
                                                 isButton={true}
                                                 label="Exportar"/>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <DataTable
                                rowClassName={props.rewardBackGroundTemplate}
                                value={props.custodyInstructions}
                                responsive={true}
                                selection={props.selectedInstruction}
                                resizableColumns={true}
                                columnResizeMode={"fit"}>
                                <Column field="loanId" header="Folio" sortable={true}/>
                                <Column field="instrumentFullName" header="Emisora" sortable={true}/>
                                <Column field="amount" header="Títulos/Imp" body={props.rewardTitlesBody}
                                        sortable={true}/>
                                <Column field="instructionMode" header="Tipo de Instrucción" sortable={true}/>
                                <Column field="origin" header="Origen" sortable={true}/>
                                <Column field="originAccount" header="Cuenta Origen" sortable={true}/>
                                <Column field="destiny" header="Destino" sortable={true}/>
                                <Column field="destinyAccount" header="Cuenta Destino" sortable={true}/>
                                <Column field="status" header="Estatus" sortable={true} body={props.errorTemplate}/>
                                <Column field="statusLoan" header="Estado del Préstamo" sortable={true}/>
                                <Column field="modifyBy" header="Usuario" sortable={true}/>
                                <Column field="modifyTime" header="Hora" sortable={true}/>
                                <Column header="Acciones"
                                        body={props.actionsTemplate}
                                        style={{textAlign: 'center', width: '8em'}}/>
                            </DataTable>
                        </Grid>
                        {props.confMsg}
                    </Grid>
                </Paper>
            </LoadingOverlay>
        </React.Fragment>
    )
};

export default CustodyTitlesView;